<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="CheckSystemType('DiveBoss')" class="NumRect">
      <div class="numList disable">
        <div @click="onGotoPage('/pro/bankList')">
          <span>{{ data.accountNum }}</span><br>
          交易账号
        </div>
        <div @click="onGotoPage('/pro/moneyCashList')">
          <span>{{ data.cachNum }}</span><br>
          提现记录
        </div>
        <div @click="onGotoPage('')">
          <span>{{ data.payNum }}</span><br>
          充值记录
        </div>
      </div>
    </div>
    <van-skeleton title :row="15" :loading="loading">
      <div v-for="item in data.moneys" :key="item.moneyId">
        <div v-if="item.manageType!=='SYSTEM' || !GetHideDiveBossCommission()" class="storeRect">
          <div class="orderLine">
            <div class="moneyName">{{ getMoneyName(item.currency) }}</div>
            <div class="title">
              <template v-if="item.manageType==='SYSTEM' && !item.masterType">
                <span>平台佣金</span>
                <div><b>{{ item.manageName }}</b>负责:平台佣金/活动等</div>
              </template>
              <template v-if="item.manageType==='SYSTEM' && item.masterType==='MANAGE'">
                <span>平台个人佣金</span>
                <div><b>{{ item.manageName }}</b>负责:平台个人佣金/奖金等</div>
              </template>
              <template v-if="item.manageType==='SYSTEM' && item.masterType==='STORE'">
                <span>平台商城佣金</span>
                <div><b>{{ item.manageName }}</b>负责:商城销售佣金</div>
              </template>
              <template v-if="item.manageType==='SYSTEM' && item.masterType==='SUPPLIER'">
                <span>平台供应佣金</span>
                <div><b>{{ item.manageName }}</b>负责:商城销售佣金</div>
              </template>
              <template v-if="item.manageType==='SYSTEM' && item.masterType==='STOREAGENT'">
                <span>平台商城代理佣金</span>
                <div><b>{{ item.manageName }}</b>负责:商城代理销售佣金</div>
              </template>
              <template v-if="item.manageType==='DIVESHOP' && item.masterType==='MANAGE'">
                <span>潜店佣金</span>
                <div><b>{{ item.manageName }}</b>负责:工资/奖金/教学佣金/提成等</div>
              </template>
              <template v-if="item.manageType==='STORE' && item.masterType==='STOREAGENT'">
                <span>商城佣金</span>
                <div><b>{{ item.manageName }}</b>负责:商城销售佣金</div>
              </template>
              <template v-if="item.manageType==='STORE' && item.masterType==='SUPPLIER'">
                <span>商品供应佣金</span>
                <div><b>{{ item.manageName }}</b>负责:供应商城销售商品佣金</div>
              </template>
              <template v-if="item.manageType==='STORE' && item.masterType==='STORE'">
                <span>商城佣金</span>
                <div><b>{{ item.manageName }}</b>负责:商城销售佣金</div>
              </template>
              <template v-if="item.manageType==='STORE' && item.masterType==='MANAGE'">
                <span>俱乐部佣金</span>
                <div><b>{{ item.manageName }}</b>负责:奖金/提成等</div>
              </template>
            </div>

            <div class="orderRect">
              <i class="iconfont iconproye" /><br>
              <span :style="'color: '+GetColorMain()">{{ item.currency }} {{ ShowMoney(item.money) }}</span>
              <div v-if="CheckSystemType('DiveBoss')">可用余额</div>
              <div v-if="CheckSystemType('SSI')">已分账金额</div>
            </div>
            <div class="orderRect">
              <i class="iconfont iconproyedj" /><br>
              <span :style="'color: '+GetColorMain()">{{ item.currency }} {{ ShowMoney(item.moneyFrozen) }}</span>
              <div v-if="CheckSystemType('DiveBoss')">冻结余额</div>
              <div v-if="CheckSystemType('SSI')">待分账金额</div>
            </div>
          </div>
          <van-row v-if="CheckSystemType('DiveBoss')">
            <van-col span="8"> <van-button type="info" square :color="GetColorMain()" style="width:100%" @click="onMoneyPay(item.moneyId)">账户充值</van-button></van-col>
            <van-col span="8"> <van-button type="info" square :color="GetColorSecondary()" style="width:100%" @click="onMoneyList(item.moneyId)">交易明细</van-button></van-col>
            <van-col span="8"> <van-button type="info" square :color="GetColorMain()" style="width:100%" @click="onMoneyCash(item.moneyId)">余额提现</van-button></van-col>
          </van-row>
          <van-row v-if="CheckSystemType('SSI')">
            <van-col span="24"> <van-button type="info" square :color="GetColorMain()" style="width:100%" @click="onMoneyList(item.moneyId)">交易明细</van-button></van-col>
          </van-row>
        </div>
      </div>
    </van-skeleton>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { getSystemMoneyExchangeList } from '@/utils/baseData'
import { GetHideDiveBossCommission, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { CheckSystemType } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的佣金',
      backurl: '/pro/index',
      loading: true,
      data: {
        accountNum: 0,
        cachNum: 0,
        payNum: 0,
        moneys: [],
        moneyExchangeList: []
      }
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.getSystemMoneyExchangeList((data) => {
      this.moneyExchangeList = data
      this.initMoneyStatistics()
    })
  },
  methods: {
    CheckSystemType,
    GetHideDiveBossCommission,
    getSystemMoneyExchangeList,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initMoneyStatistics() {
      request({
        url: '/pro/getMoneyStatistics',
        method: 'post'
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        // this.data.moneys.forEach(item => {
        //   this.list.forEach(config => {
        //     if (item.currency === config.currency && item.manageType === config.manageType && item.masterType === config.masterType) {
        //       config.data = item
        //     }
        //   })
        // })
      })
    },
    getMoneyName(currency) {
      var list = this.moneyExchangeList.filter(item => item.targetCurrency === currency)
      if (list.length <= 0) {
        return ''
      }
      return list[0].targetName
    },
    onMoneyPay(moneyId) {
      MyNotify('info', '功能暂未开放，请稍等!')
    },
    onMoneyList(moneyId) {
      this.$router.push('/pro/moneyList?moneyId=' + moneyId)
    },
    onMoneyCash(moneyId) {
      this.$router.push('/pro/moneyCash/' + moneyId)
    },
    onGotoPage(url) {
      if (!url || url === '') {
        MyNotify('info', '功能暂未开放，请稍等!')
        return
      }
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.storeRect {
  margin: 1em 0.5em;
  border-radius: 0.4em;
   overflow: hidden;
}
.storeRect .orderLine{
  background-color: #fff;
  display:flex;
  padding-bottom: 0.8em;
  padding: 1em;
  position: relative;
}
.storeRect .orderLine .moneyName{
  position: absolute;
  right: 0;
  font-size: 5em;
  color: #f5f5f5;
}
.NumRect{
  margin: 1em 0.5em;
  overflow: hidden;
  background-color: #fff;
  border-radius: 0.4em;
  padding: 1em;
}
.NumRect .numList{
  display:flex;
  padding-top: 0.8em;
}
.NumRect .numList div{
  text-align: center;
  flex:1;
  font-size: 0.9em;
  line-height: 1.5em;
}
.NumRect .numList span{
  font-size: 1.5em;
  font-weight: 700;
}

.storeRect .orderLine .orderRect{
  position: relative;
  text-align: center;
  flex:1;
  line-height: 1.5em;
}

.storeRect .orderLine .title{
  font-size: 1em;
  width: 34vw;
}
.storeRect .orderLine .title div{
  font-size: 0.8em;
  color: #999;
  margin-top: 0.5em;
}
.storeRect .orderLine span{
  font-size: 0.9em;
}
.storeRect .orderLine .orderRect i{
  font-size: 2em;
}
.storeRect .orderLine .orderRect div{
  font-size: 0.6em;
  color: #999;
  margin-top: 0.5em;
  line-height: 0.8em;
}
.storeRect .orderLine .orderRect .num{
  position:absolute;
  right: 2em;
  top: 0em;
  color: #fff;
  font-size: 0.7em;
  border-radius: 1em;
  text-align: center;
  width: 1.4em;
  height: 1.4em;
  line-height: 1.4em;
}
</style>
